import { doesExist } from 'utils/tsHelpers';
import { useIsMultiValueCondition } from './useIsMultiValueCondition';
import { useOnFieldChange } from './useOnFieldChange';
import { longFieldsWithoutCastType } from '../constants';
import { ConditionRendererProps } from '../ConditionRenderer';
import { DefaultComparator, FieldType } from '../../../types';
import { useConditionStateContext } from '../../../contexts';
import { useIsCatalogESIndex } from 'modules/queryBuilder/hooks/useIsCatalogESIndex';

/**
 *  Hook to store all condition renderer logic
 */

export const useConditionRendererState = ({ dataType }: ConditionRendererProps) => {
  const {
    comparator = null,
    field = '',
    fieldType = FieldType.UNDEFINED,
    values,
  } = useConditionStateContext();
  const hasField = doesExist(field) && doesExist(FieldType) && fieldType !== FieldType.UNDEFINED;
  const isMultiValueCondition = useIsMultiValueCondition();
  const onFieldChange = useOnFieldChange(dataType);
  const isValueInputVisible =
    hasField &&
    comparator !== DefaultComparator.IS_SET &&
    comparator !== DefaultComparator.IS_NOT_SET &&
    !(
      (fieldType === FieldType.GEO_LOCATION ||
        fieldType === FieldType.NESTED ||
        fieldType === FieldType.OBJECT) &&
      !doesExist(comparator)
    ); // hide value input for geo location, nested, and object as they only have is set and is not set comparators available

  const isMultiSelect = doesExist(values);
  const isCatalogESIndex = useIsCatalogESIndex();
  const isCastTypeSelectVisible =
    fieldType === FieldType.INTEGER &&
    !longFieldsWithoutCastType.includes(field) &&
    !isMultiSelect &&
    isValueInputVisible &&
    !isCatalogESIndex;

  return {
    isMultiValueCondition,
    isComparatorSelectVisible: hasField,
    isValueInputVisible,
    isCastTypeSelectVisible,
    onFieldChange,
  };
};
